import { Day, eachDayOfInterval, endOfWeek, format, startOfWeek } from "date-fns";
import { upperFirst } from "./upperFirst";

export const getWeekDays = (dayFormat: string, weekStartsOn: Day) => {
  const now = new Date();

  const start = startOfWeek(now, { weekStartsOn });
  const end = endOfWeek(now, { weekStartsOn });

  return eachDayOfInterval({ start, end }).map((day) => {
    return upperFirst(format(day, dayFormat), true);
  });
};

export const getMonths = (monthFormat: string) => {
  const monthNames: string[] = [];

  for (let month = 0; month < 12; month++) {
    const date = new Date(2020, month, 1);
    monthNames.push(upperFirst(format(date, monthFormat), true));
  }

  return monthNames;
};
